export default __webpack_public_path__ + "images/JS.c1f0142.png";